import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, InputNumber } from "antd";
import api from "../../api";
import { useToast } from "../../components/toast";

const ICON_OPTIONS = [
  { value: "digital", label: "Дижитал зээл" },
  { value: "savings", label: "Хадгаламж" },
  { value: "car", label: "Автомашин" },
];

export default function KeywordFormModal({
  open,
  editingRow,
  existingGroups,
  onClose,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const keyValue = Form.useWatch("key", form);
  const toast = useToast();
  const isEdit = !!editingRow;

  useEffect(() => {
    if (open && editingRow) {
      form.setFieldsValue({
        ...editingRow,
        group: editingRow.group ? [editingRow.group] : [],
      });
    } else if (open) {
      form.resetFields();
    }
  }, [open, editingRow]);

  const onSave = async () => {
    const values = await form.validateFields();
    setSaving(true);

    const payload = {
      key: values.key,
      label: values.label || null, // ← нэмэгдсэн
      value: values.value,
      group: values.group?.[0] || null,
      sortOrder: values.sortOrder ?? 0,
    };

    const res = isEdit
      ? await api.keywords_update(editingRow.id, payload)
      : await api.keywords_create(payload);

    if (res?.status === 200 || res?.status === 201) {
      toast("Амжилттай хадгаллаа", "success");
      onSuccess();
      onClose();
    } else {
      toast(res?.data?.message || "Алдаа гарлаа", "error");
    }
    setSaving(false);
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={onSave}
      confirmLoading={saving}
      title={isEdit ? "Keyword засах" : "Keyword нэмэх"}
      okText="Хадгалах"
      cancelText="Болих"
      width={440}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        {/* 1. Түлхүүр */}
        <Form.Item
          name="key"
          label="Түлхүүр"
          rules={[{ required: true, message: "Түлхүүр оруулна уу" }]}
          tooltip="Дан бол код нэр (contact_address). Групптэй бол картын гарчиг (Аппын зээл). Табын icon бол _icon"
        >
          <Input placeholder="contact_address эсвэл Аппын зээл" />
        </Form.Item>

        {/* 2. Мөрийн нэр — групптэй keyword-д */}
        <Form.Item
          name="label"
          label="Мөрийн нэр"
          tooltip="Групптэй үед картын мөрийн нэр: Санал болгох хүү (1 сар). Дан keyword-д хоосон орхино"
        >
          <Input placeholder="Санал болгох хүү (1 сар)" />
        </Form.Item>

        {/* 3. Утга — key нь _icon бол Select, бусад үед TextArea */}
        <Form.Item
          name="value"
          label="Утга"
          rules={[{ required: true, message: "Утга оруулна уу" }]}
        >
          <Input.TextArea rows={2} placeholder="2.80%" />
        </Form.Item>

        {/* 4. Бүлэг */}
        <Form.Item
          name="group"
          label="Бүлэг"
          tooltip="Хоосон бол дан keyword. Байгаа бүлгээс сонгох эсвэл шинэ нэр бичиж үүсгэнэ — бүлгийн нэр нь сайт дээр табын нэр болно"
        >
          <Select
            mode="tags"
            maxCount={1}
            allowClear
            placeholder="Дижитал зээл"
            options={existingGroups.map((g) => ({ value: g, label: g }))}
          />
        </Form.Item>

        {/* 5. Эрэмбэ */}
        <Form.Item name="sortOrder" label="Эрэмбэ" initialValue={0}>
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
